import { useMutation } from 'react-query';
import { projectService } from 'ogp/services';
import { OgpProjectCreatePayload } from 'ogp/services/project-service.types';
import { useInvalidateQuery } from 'shared/hooks/query-hooks/useInvalidateQuery';
import { QUERY_KEYS } from 'api/query-keys';

export const useCreateProject = () => {
  const mutationFn = async (project: OgpProjectCreatePayload) =>
    await projectService.createProject(project);
  const invalidateQuery = useInvalidateQuery();
  return useMutation(mutationFn, {
    onSuccess: () => {
      invalidateQuery(QUERY_KEYS.projects());
    },
  });
};
